import CrudCustom from '../../../libs/custom/CrudCustom';

let PPh21TidakFinalService = new CrudCustom('/p-ph-21-tidak-finals');
export default PPh21TidakFinalService;
